
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorChatActivo } from '../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
import { Utiles } from '@/__env/pluggins/event-bus';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorChatActivo;
        public get Chat() { return this.Controlador.Chat; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.ReservarEspacioDerecha.Espacio; }
        public get ControladorBarras() { return this.Controlador.ControladorBarrasLaterales; }
        public get Modo() { return this.ControladorBarras.Vista.Modo; }
        public set Modo( x: string ) { this.ControladorBarras.Vista.Modo = x; }
        public get SubModo() { return this.ControladorBarras.Vista.SubModo; }
        public set SubModo( x: string ) { this.ControladorBarras.Vista.SubModo = x; }

        public Facturas: Factura[] = [];

        mounted()
        {
            this.Eventos.push( this.ControladorBarras.Vista.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'facturas' )
                {
                    this.Controlador.Vista.ReservarEspacioDerecha.Espacio = 400;
                }
            } ) );

            this.SubModo = 'facturas';
            this.Iniciar();
        }

        public SoloFacturas: boolean = false;
        @Watch( 'SoloFacturas' )
        onSoloFacturas()
        {
            this.Iniciar();
        }

        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            this.Cargando = true;
            this.Facturas.clear();
            let bb: any = { cliente: this.Chat.Cliente.Id, order: 'fecha', sort: 'DESC' };
            if ( this.SoloFacturas )
            {
                bb.tipo_movimiento = 1;
            }

            let e = await Factura.find( bb );
            if ( e.Items.hasRows() )
                this.Facturas = e.Items;
            this.Cargando = false;
        }

        public async Abrir( item: Factura )
        {
            let pdf = await Factura.URLFactura( [item] );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `No se encontró el PDF de la factura` );
            }
        }

        public async EnviarAlCliente( item: Factura )
        {
            let pdf = await Factura.URLFactura( [item] );
            if ( pdf )
            {

                let e = await this.Controlador.NuevoMensaje.AgregarArchivoUrl( { Nombre: item.Linea.replace(' ','_') , Ruta: pdf } );
                if ( e == 'demasiado-grande' )
                {
                    Utiles.Notificaciones.Error( '¡El archivo es demasiado grande!' );
                }
                else if ( e == 'error' )
                {
                    Utiles.Notificaciones.Error( '¡Error al subir el archivo!' );
                }

            } else
            {
                Utiles.Notificaciones.Error( `No se encontró el PDF de la factura` );
            }
        }


        Cerrar()
        {
            this.Modo = 'menu';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
